import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
import { fade } from '@material-ui/core/styles';

var createPalette = function createPalette(_ref) {
  var type = _ref.type,
      blue30 = _ref.blue30,
      blue400 = _ref.blue400,
      blue500 = _ref.blue500,
      grey20 = _ref.grey20,
      grey90 = _ref.grey90,
      grey100 = _ref.grey100,
      grey600 = _ref.grey600,
      grey900 = _ref.grey900,
      white = _ref.white,
      unknown = _ref.unknown;

  if (type === 'light') {
    return {
      color1: grey90,
      color2: blue30,
      color3: blue400,
      color4: blue500,
      color5: white,
      color6: grey20,
      unknown: unknown
    };
  }

  return {
    color1: grey100,
    color2: fade(blue500, 0.4),
    color3: blue400,
    color4: blue400,
    color5: grey900,
    color6: grey600,
    unknown: unknown
  };
};

var createEditable1 = function createEditable1(_ref2) {
  var color1 = _ref2.color1,
      color2 = _ref2.color2,
      color3 = _ref2.color3,
      color4 = _ref2.color4;
  return {
    "default": {
      background: 'none',
      borderColor: color1
    },
    active: {
      borderColor: color4
    },
    hover: {
      borderColor: color3,
      indicatorColor: color2
    }
  };
};

var createEditable2 = function createEditable2(_ref3) {
  var color1 = _ref3.color1,
      color2 = _ref3.color2,
      color3 = _ref3.color3,
      color4 = _ref3.color4,
      color5 = _ref3.color5;
  return {
    "default": {
      background: color5,
      borderColor: color1
    },
    active: {
      borderColor: color4
    },
    hover: {
      borderColor: color3,
      indicatorColor: color2
    }
  };
};

var createEditable3 = function createEditable3(_ref4) {
  var color1 = _ref4.color1,
      color2 = _ref4.color2,
      color3 = _ref4.color3,
      color4 = _ref4.color4,
      color6 = _ref4.color6;
  return {
    "default": {
      background: color6,
      borderColor: color1
    },
    active: {
      borderColor: color4
    },
    hover: {
      borderColor: color3,
      indicatorColor: color2
    }
  };
};

var createGetEditable = function createGetEditable(options) {
  return function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$variant = _ref5.variant,
        variant = _ref5$variant === void 0 ? 'editable1' : _ref5$variant,
        _ref5$density = _ref5.density,
        density = _ref5$density === void 0 ? 'medium' : _ref5$density,
        _ref5$state = _ref5.state,
        state = _ref5$state === void 0 ? 'default' : _ref5$state;

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (!hasOwnProperty.call(options, variant)) {
      return undefined;
    }

    var variantByDensity = hasOwnProperty.call(options[variant], density) ? options[variant][density] : {};

    if (state) {
      return variantByDensity[state] || {};
    }

    return variantByDensity;
  };
};

export var createEditable = function createEditable(palette) {
  var editable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref6 = typeof editable === 'function' ? editable(palette) : editable,
      otherGetEditable = _ref6.getEditable,
      otherOptions = _objectWithoutProperties(_ref6, ["getEditable"]);

  var editablePalette = createPalette(palette);
  var options = ['touch', 'low', 'medium', 'high'].reduce(function (result, density) {
    return {
      editable1: _assign({}, result.editable1, _defineProperty({}, density, createEditable1(editablePalette))),
      editable2: _assign({}, result.editable2, _defineProperty({}, density, createEditable2(editablePalette))),
      editable3: _assign({}, result.editable3, _defineProperty({}, density, createEditable3(editablePalette)))
    };
  }, {});
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getEditable: otherGetEditable || createGetEditable(mergedOptions)
  }, mergedOptions);
};